// src/components/plataforma/contas/ContaDashboardPage.js
import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Building, Users, Settings, ArrowLeft, Loader2, AlertTriangle, Globe } from 'lucide-react'; // ✅ Adicionado Globe
import { useAccountById } from '../../../hooks/useAccounts';

const ContaDashboardPage = () => {
    const { id: contaId } = useParams();
    const navigate = useNavigate();

    const { data: accountDetails, isLoading, error } = useAccountById(contaId);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-64">
                <Loader2 className="animate-spin text-indigo-600" size={40} />
            </div>
        );
    }

    if (error) {
        return (
            <div className="content-panel-error">
                <AlertTriangle size={40} className="text-red-500" />
                <h2 className="text-xl font-bold mt-4">Erro ao carregar a conta</h2>
                <p className="text-red-600">{error.message}</p>
            </div>
        );
    }

    if (!accountDetails) {
        return <div className="p-8 text-center">Nenhuma informação da conta encontrada.</div>;
    }

    const handleVoltar = () => {
        if (accountDetails.franquia && accountDetails.franquia._id) {
            navigate(`/franquias/${accountDetails.franquia._id}/contas`);
        } else {
            navigate('/plataforma/contas');
        }
    };

    return (
        <div className="page-management-container">
            <div className="page-header">
                <div className="flex items-center gap-4">
                    <button
                        onClick={handleVoltar}
                        className="action-button action-button-secondary"
                    >
                        <ArrowLeft size={16} className="icon" />
                        Voltar
                    </button>
                    <h1 className="page-title">
                        <Building className="icon text-indigo-600" />
                        {accountDetails.name}
                    </h1>
                </div>
                <p className="text-gray-500 ml-12 mt-1">Gerenciado por: {accountDetails.owner?.name}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                <Link to={`/contas/${contaId}/equipe`} className="dashboard-card">
                    <Users className="dashboard-card-icon text-blue-500" />
                    <h3 className="dashboard-card-title">Gerenciar Equipe</h3>
                    <p className="dashboard-card-text">
                        Adicione, edite e gerencie os profissionais e usuários da conta.
                    </p>
                </Link>

                <Link to={`/contas/${contaId}/configuracoes`} className="dashboard-card">
                    <Settings className="dashboard-card-icon text-green-500" />
                    <h3 className="dashboard-card-title">Configurações</h3>
                    <p className="dashboard-card-text">
                        Ajuste os dados cadastrais da empresa.
                    </p>
                </Link>

                {/* ✅ NOVO MENU: Página Pública */}
                <Link to={`/contas/${contaId}/pagina-publica`} className="dashboard-card">
                    <Globe className="dashboard-card-icon text-purple-500" />
                    <h3 className="dashboard-card-title">Página Pública</h3>
                    <p className="dashboard-card-text">
                        Configure a página pública da sua empresa.
                    </p>
                </Link>
            </div>
        </div>
    );
};

export default ContaDashboardPage;